
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.25 12a5.25 5.25 0 10-9 3.67V21a.75.75 0 001.086.671L18 20.338l2.664 1.333A.75.75 0 0021.75 21v-5.33a5.233 5.233 0 001.5-3.67zM18 8.25a3.75 3.75 0 110 7.5 3.75 3.75 0 010-7.5zm.336 10.579a.75.75 0 00-.672 0l-1.914.958v-3.044a5.245 5.245 0 004.5 0v3.044l-1.914-.958zM12.75 18a.75.75 0 01-.75.75H3.75a1.5 1.5 0 01-1.5-1.5v-12a1.5 1.5 0 011.5-1.5h16.5a1.5 1.5 0 011.5 1.5.75.75 0 11-1.5 0H3.75v12H12a.75.75 0 01.75.75zm-1.5-5.25a.75.75 0 01-.75.75H6.75a.75.75 0 110-1.5h3.75a.75.75 0 01.75.75zm0-3a.75.75 0 01-.75.75H6.75a.75.75 0 110-1.5h3.75a.75.75 0 01.75.75z"}})])
          )
        }
      }
    